/* SETTINGS */
export const CHANGE_LOCALE = 'CHANGE_LOCALE';

/* AUTH */
export const LOGIN_USER = 'LOGIN_USER';
export const LOGIN_USER_SUCCESS = 'LOGIN_USER_SUCCESS';
export const LOGIN_USER_ERROR = 'LOGIN_USER_ERROR';
export const REGISTER_USER = 'REGISTER_USER';
export const REGISTER_USER_SUCCESS = 'REGISTER_USER_SUCCESS';
export const REGISTER_USER_ERROR = 'REGISTER_USER_ERROR';
export const LOGOUT_USER = 'LOGOUT_USER';
export const FORGOT_PASSWORD = 'FORGOT_PASSWORD';
export const FORGOT_PASSWORD_SUCCESS = 'FORGOT_PASSWORD_SUCCESS';
export const FORGOT_PASSWORD_ERROR = 'FORGOT_PASSWORD_ERROR';
export const RESET_PASSWORD = 'RESET_PASSWORD';
export const RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS';
export const RESET_PASSWORD_ERROR = 'RESET_PASSWORD_ERROR';
export const PICTURE_USER = 'PICTURE_USER';
export const USER_OFFICES = 'USER_OFFICES';
export const SET_ROL_USER = 'SET_ROL_USER';
export const SET_OLD_PASS = 'SET_OLD_PASS';
export const USER_CONCESSIONAIRE = 'USER_CONCESSIONAIRE';
export const NAV_CONTENT = 'NAV_CONTENT';
export const SET_EMAIL = 'SET_EMAIL';
export const SET_TOKEN_EXPIRED = 'SET_TOKEN_EXPIRED';

/* MENU */
export const MENU_SET_CLASSNAMES = 'MENU_SET_CLASSNAMES';
export const MENU_CONTAINER_ADD_CLASSNAME = 'MENU_CONTAINER_ADD_CLASSNAME';
export const MENU_CLICK_MOBILE_MENU = 'MENU_CLICK_MOBILE_MENU';
export const MENU_CHANGE_DEFAULT_CLASSES = 'MENU_CHANGE_DEFAULT_CLASSES';
export const MENU_CHANGE_HAS_SUB_ITEM_STATUS =
    'MENU_CHANGE_HAS_SUB_ITEM_STATUS';

/*** CREDIT */
export const CREDIT_SET_DATA = 'CREDIT_SET_DATA';
export const CREDIT_FORM_SET_DATA = 'CREDIT_FORM_SET_DATA';
export const CALCULATOR_SET_DATA = 'CALCULATOR_SET_DATA';
export const TIPO_PERSONA = 'TIPO_PERSONA';

/*** CLIENT */
export const CLIENT_SET_DATA = 'CLIENT_SET_DATA';
export const RESET_CREDIT_DATA = 'RESET_CREDIT_DATA';

/**GLOBALS */
export const GLOBAL_SET_DATA = 'GLOBAL_SET_DATA';

/** Wizard */
export const WIZARD_SET_DATA = 'WIZARD_SET_DATA';
export const TRIGGER_SET_DATA = 'TRIGGER_SET_DATA';
export const JUMP_FIRST_STEP = 'JUMP_FIRST_STEP';
export const RESPONSABLE_LOADED = 'RESPONSABLE_LOADED';
export const ERROR_INFORMATION_CREDIT = 'ERROR_INFORMATION_CREDIT';

/*** DEPENDENCE */
export const DEPENDENCE_SET_DATA = 'DEPENDENCE_SET_DATA';

/*** CODEBTOR */
export const CODEBTOR_SET_DATA = 'CODEBTOR_SET_DATA';
export const CODEBTOR_TRIGGER_SET_DATA = 'CODEBTOR_TRIGGER_SET_DATA';

/*** VALIDATIONS */
export const VALIDATIONS_SET_DATA = 'VALIDATIONS_SET_DATA';

/*** GENERAL */
export const MODAL_REASSIGN_USER_SET_DATA = 'MODAL_REASSIGN_USER_SET_DATA';
export const MODAL_RESUME_REQUEST_SET_DATA = 'MODAL_RESUME_REQUEST_SET_DATA';
export const FILTER_DINAMIC_SET_DATA = 'FILTER_DINAMIC_SET_DATA';
export const GROUP_USER_REASING = 'GROUP_USER_REASING';
export const IS_ACTIVE_CONCESSIONAIRE = 'IS_ACTIVE_CONCESSIONAIRE';
export const LOADING_PEACE_SAFE = 'LOADING_PEACE_SAFE';
export const LOADING_GENERATE_DODUMENT = 'LOADING_GENERATE_DODUMENT';
export const FILTER_DINAMIC_COMPARATIVE_MONTHS =
    'FILTER_DINAMIC_COMPARATIVE_MONTHS';
export const FILTER_DINAMIC_TEAM_PERFORMANCE =
    'FILTER_DINAMIC_TEAM_PERFORMANCE';
export const GROUP_USER_GENERAL = 'GROUP_USER_GENERAL';
export const VIEW_BUTTON_EDIT_CONTACT_CLIENT =
    'VIEW_BUTTON_EDIT_CONTACT_CLIENT';
export const NO_SHOW_COMPONENT_IN_MENU = 'NO_SHOW_COMPONENT_IN_MENU';
export const NO_SHOW_MODAL = 'NO_SHOW_MODAL';
export const CHANGE_INFO_CONTAINER = 'CHANGE_INFO_CONTAINER';
export const STATE_VERIFIK = 'STATE_VERIFIK';
export const STATE_VERIFIK_START = 'STATE_VERIFIK_START';
export const STATE_SUMMARY_CREDIT_MODAL = 'STATE_SUMMARY_CREDIT_MODAL';
export const STATE_OBSERVATION_MODAL = 'STATE_OBSERVATION_MODAL';
export const OCULTAR_SECCION = 'OCULTAR_SECCION';
export const STATE_SUMMARY_EMPLOYEE_CREDIT_MODAL =
    'STATE_SUMMARY_EMPLOYEE_CREDIT_MODAL';
export const STATE_RECORD_VISIT_MODAL = 'STATE_RECORD_VISIT_MODAL';
export const STATE_GENERAL_DATA = 'STATE_GENERAL_DATA';

/** EMPLOYEES CREDIT */
export const EMPLOYEES_CREDIT_DATA = 'EMPLOYEES_CREDIT_DATA';

/** MODAL STATES */
export const MODAL_STATUS = 'MODAL_STATUS';

export const VEHICLE_WARRANTY_DATA = 'VEHICLE_WARRANTY_DATA';
export const FINANCIAL_SOLUTION = 'FINANCIAL_SOLUTION';

export * from './menu/actions';
export * from './settings/actions';
export * from './auth/actions';
export * from './credit/actions';
export * from './globals/actions';
export * from './client/actions';
export * from './wizard/actions';
export * from './errors/actions';
export * from './dependencies/actions';
export * from './codebtor/actions';
export * from './validations/actions';
export * from './general/actions';
export * from './creditEmployees/actions';
export * from './modals/actions';
export * from './waranty/actions';
